export const muiFormGroupOverrides = {
	styleOverrides: {
		root: ({ theme }) => {
			return {
				alignContent: 'flex-start',
				padding: `0 ${theme.tsGoUnit.tsUnitQuarter} ${theme.tsGoUnit.tsUnit} ${theme.tsGoUnit.tsUnitQuarter}`,

				'& > :first-of-type': {
					width: '100%',
				},
			};
		},
	},
};
